import HTTPClient from "../../services/AxiosClient";
import ObjectHelper from "../../helpers/ObjectHelper";


HTTPClient.interceptors.request.use(function (config) {

	if (config && !(config.data instanceof FormData)) {

		if (config.data) {
			const { data } = config;
			config.data = ObjectHelper.limparDados(data, true);
		}

		if (config.params) {
			const { params } = config;
			config.params = ObjectHelper.limparDados(params);
		}

	}

    return config;
}, function (error) {
    return Promise.reject(error);
});

